import AppNavTabs from './AppNavTabs';

export default AppNavTabs;
